import { Directive, ElementRef, OnInit, Optional, Self } from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';
import { Select } from 'primeng/select';

// opens the panel of a primeng dropdown inside a material dialog's overlay pane.
// appended to body the panel lands off by the page scroll: while a dialog is open its
// scroll block shifts the page up, which primeng's positioning doesn't account for
@Directive({
    selector: 'p-select[appDialogPanel], p-multiselect[appDialogPanel]',
    standalone: false
})
export class DialogPanelDirective implements OnInit {

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    @Optional() @Self() private select: Select,
    @Optional() @Self() private multiSelect: MultiSelect
  ) { }

  ngOnInit(): void {
    const pane = this.elementRef.nativeElement.closest<HTMLElement>('.cdk-overlay-pane');
    const dropdown = this.select ?? this.multiSelect;
    dropdown.appendTo = pane ?? 'body';
  }
}
